module.exports = __webpack_public_path__ + "assets/img/index2.164d7db3.jpg";